import React, { useState, useRef, useEffect } from "react";

import { Sidebar } from "primereact/sidebar";
import BottomSheetViewForm from "./BottomSheetViewForm";

const { innerWidth: width, innerHeight: height } = window;

const BottomSheetView = ({
  visible,
  toggleBottomNavigationView,
  toggleBottomNavigationViewClosed,
  selectedGarment,
  onAddToCart,
  storeId,
  selectedPriceId,
  storeCustomerId,
  BookingType,
  offerPriceEnabled,
  enabledAutoSelectAppService,
  storeUserId,
  brandId,
  bookingOrderId,
  storeGarmentRemarksData,
  enabledPreDefinedRemark,
  garmentMaxProcessCount,
  garmentServiceIcons,
  userProfileData,
  storeGarmentRemarksPriorityData,
  B2BModel,
  enabledAmountRoundOff
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [img, setImg] = useState("");
  const [categoryName, setCategoryName] = useState("");

  useEffect(() => {
    if (selectedGarment) {
      const {
        garment: { name, code, description, logo },
        category: { name: categoryName },
        id,
      } = selectedGarment;
      setName(name);
      setDescription(description);
      setImg(logo);
      setCategoryName(categoryName); // Corrected from setAmount(nameName);
    }
  }, [selectedGarment]);

  return (
    <div>
      <div>
        <Sidebar
          visible={visible}
          position="bottom"
          onHide={() => toggleBottomNavigationViewClosed(false)}
          style={{
            justifyContent: "flex-start",
          }}
          header={
            <div className="flex gap-4">
              <div>
                <img
                  src={
                    img !== null
                      ? `data:image/jpeg;base64,${img}`
                      : "Laundry_app_icons/Tshirt.png"
                  }
                  resizeMode="cover"
                  style={{
                    alignSelf: "center", // to center an image
                    width: height < 600 ? 60 : 70,
                    height: height < 600 ? 60 : 70,
                  }}
                />
              </div>
              <div className="flex flex-1 flex-column justify-content-center">
                <p className="text-lg text-black-alpha-90 font-semibold text-center">
                  {name.replace(/_/g, " ")}
                </p>
                <p className="text-lg text-black-alpha-90 font-semibold text-center">
                  {categoryName}
                </p>
              </div>
            </div>
          }
        >
          <div className="border-1" style={{ color: "#c2c2c2" }}></div>
          <div>
            <div />
            <BottomSheetViewForm
              onAddToCart={onAddToCart}
              selectedGarment={selectedGarment}
              onClose={toggleBottomNavigationViewClosed}
              storeId={storeId}
              selectedPriceId={selectedPriceId}
              storeCustomerId={storeCustomerId}
              BookingType={BookingType}
              offerPriceEnabled={offerPriceEnabled}
              enabledAutoSelectAppService={enabledAutoSelectAppService}
              storeUserId={storeUserId}
              brandId={brandId}
              bookingOrderId={bookingOrderId}
              storeGarmentRemarksData={storeGarmentRemarksData}
              enabledPreDefinedRemark={enabledPreDefinedRemark}
              garmentMaxProcessCount={garmentMaxProcessCount}
              garmentServiceIcons={garmentServiceIcons}
              userProfileData={userProfileData}
              storeGarmentRemarksPriorityData={storeGarmentRemarksPriorityData}
              B2BModel={B2BModel}
              enabledAmountRoundOff={enabledAmountRoundOff}
            />
          </div>
        </Sidebar>
      </div>
    </div>
  );
};

export default BottomSheetView;
